import React, {useId} from 'react'
import PropTypes from 'prop-types'
import {Box, Popover, PopoverTrigger, PopoverContent, PopoverArrow, Text} from '@chakra-ui/react'
import useBreakpoints from '../../hooks/use-breakpoints'

export const InfoIconTooltip = ({
    name,
    helpText,
    icon: Icon,
    iconProps = {},
    variant = 'feedbackReportTooltip'
}) => {
    const infoIconId = useId()
    const isMobile = useBreakpoints({base: true, lg: false})

    const content =
        typeof helpText === 'string' ? (
            <Box dangerouslySetInnerHTML={{__html: helpText}} />
        ) : (
            helpText
        )

    return (
        <Popover
            trigger={isMobile ? 'click' : 'hover'}
            variant={variant}
            placement="top"
            closeOnBlur={false}
        >
            <PopoverTrigger>
                <Box
                    as="span"
                    tabIndex={0}
                    aria-describedby={infoIconId}
                    data-testid={`${name}-${isMobile ? 'mobile' : 'desktop'}-tooltip-testid`}
                    display="inline-flex"
                    alignItems="center"
                >
                    <Icon
                        variant="tooltip"
                        verticalAlign="top"
                        role="presentation"
                        {...iconProps}
                    />
                    <Text as="div" className="sr-only">
                        {content}
                    </Text>
                </Box>
            </PopoverTrigger>
            <PopoverContent as="div" id={infoIconId} role="tooltip">
                <PopoverArrow />
                <Text as="div">{content}</Text>
            </PopoverContent>
        </Popover>
    )
}

InfoIconTooltip.propTypes = {
    name: PropTypes.string.isRequired,
    helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    icon: PropTypes.elementType.isRequired,
    iconProps: PropTypes.object,
    variant: PropTypes.string
}
